const Loading = () => {
  return (
    <div className="loading">
      <div className="loading-text">PUMPING TO THE MOON... 🚀</div>
    </div>
  );
};

export default Loading;
